import React from 'react';
import { useTranslation } from 'react-i18next';

import StatusChip from '@sophocles/components/StatusChip';

export default function TicketResolvedChip({ resolution }) {
  const { t } = useTranslation();
  const isResolved = Boolean(resolution && String(resolution).trim().length > 0);
  return (
    <StatusChip
      label={isResolved ? t('support.resolved', 'Resolved') : t('support.open', 'Open')}
      color={isResolved ? 'ok' : 'warning'}
    />
  );
}
